// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1tdVD","title":"ClientInsurance_title__3rz6I","itemText":"ClientInsurance_itemText__3hzTv"};